export enum BookmarkAction {
  Bookmark = "Bookmark",
  UnBookmark = "UnBookmark",
}
